export default __webpack_public_path__ + "static/media/cs-a018-3.efe58545.svg";